import { forwardRef, type SelectHTMLAttributes } from "react";
import { cn } from "../cn";

export interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  invalid?: boolean;
}

export const Select = forwardRef<HTMLSelectElement, SelectProps>(function Select(
  { className, invalid, children, ...rest },
  ref,
) {
  return (
    <select
      ref={ref}
      aria-invalid={invalid ? "true" : undefined}
      className={cn(
        "border-charcoal/20 bg-cream text-body text-charcoal h-11 w-full appearance-none rounded-md border px-3 py-2",
        "focus-visible:ring-saffron focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-1",
        "disabled:cursor-not-allowed disabled:opacity-50",
        invalid && "border-terracotta focus-visible:ring-terracotta",
        className,
      )}
      {...rest}
    >
      {children}
    </select>
  );
});
